// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".renewal-wrapper{min-height:300px}.content-wrapper{width:90%;max-width:714px}.st0{fill:url(#SVGID_1_)}.st1{fill:url(#SVGID_00000040575453145413792080000000397794096398363320_)}.st3{fill:#fff}", ""]);
// Exports
module.exports = exports;
